import Cookie from 'js-cookie'
import appConfig from '../config'
import types from '../store/types'
import Vue from 'vue'

function fetchUser (store, isWx = false) {
  let openid = Cookie.get(appConfig.cookie.OPENID)
  return store.dispatch(types.app.GET_USER, {
    [appConfig.cookie.OPENID]: isWx ? openid : null
  })
}

export function interceptor (router, store) {
  router.beforeEach((to, from, next) => {
    try {
      Vue.prototype.$Progress.start()
      let token = Cookie.get(appConfig.cookie.TOKEN)
      let user = store.state.app.user
      let url = to.query[appConfig.cookie.REDRIECT_URL] ? to.query[appConfig.cookie.REDRIECT_URL] : to.fullPath
      let ua = window.navigator.userAgent.toLowerCase()
      let isWx = ua.match(/MicroMessenger/i) == 'micromessenger'
      // 页面是否需要权限
      if (to.meta.auth) {
        let type = Number(to.query.type) // 授权类型
        // 进入登录页 的情况
        if (token && user && (to.name === 'login' || to.name === 'register')) {
          // 用户已经登录
          next({path: '/'})
          return
        }
        if (isWx) { // 微信做单独处理
          // 直接进入登录（绑定）页面 没有openid不能进登录和注册页（流程要求）
          if ((!token && to.name === 'login') || (token && !user && to.name === 'login')) {
            // 拉取用户信息 (用户主动刷新页面会出现)
            fetchUser(store, true).then(() => {
              // 去首页
              next({path: '/'})
            }).catch(() => {
              // 老老实实去绑定
              next()
            })
            return
          }
          if (to.query.url) {
            url = to.query.url
          }
          if (to.name === 'auth' && token && !user) { // 进入授权页面 可能存在问题
            // 先尝试拉取一次用户信息，因为如果用户一直进这个页面都导致死循环
            fetchUser(store, true).then(() => {
              // 去首页
              next({path: '/'})
            }).catch(() => {
              // alert('我没拉取到用户，要死循环了。。。。')
              // 绑定或注册成功后重定向的页面
              Cookie.set(appConfig.cookie.REDRIECT_URL, url, {
                path: '/'
              })
              next({query: {
                type: appConfig.plaltform.WX,
                url
              }})
            })
            return
          } else if (to.name === 'auth' && user && token) {
            next({path: ''})
            return
          } else if (to.name === 'auth' && !token) {
            next()
            return
          }
          if (!token) { // 其余一律进入授权页面
            // 绑定或注册成功后重定向的页面
            Cookie.set(appConfig.cookie.REDRIECT_URL, url, {
              path: '/'
            })
            next({name: 'auth',
              query: {
                type: appConfig.plaltform.WX,
                url
              }})
          } else if (token && !user) {
            fetchUser(store, true).then(() => {
              next()
            }).catch(() => {
              Cookie.set(appConfig.cookie.REDRIECT_URL, url, {
                path: '/'
              })
              next({name: 'auth',
                query: {
                  type: appConfig.plaltform.WX,
                  url
                }})
            })
          } else {
            next()
          }
        } else { // 其余情况
          // 处理登录页
          if (!token && to.name === 'login') {
            next()
            return
          } else if (token && user && to.name === 'login') {
            next({path: '/'})
            return
          } else if (token && !user && to.name === 'login') {
            fetchUser(store).then(() => {
              next({path: '/'})
            }).catch(() => {
              next()
            })
            return
          }
          // 要进入的是授权页面的情况
          let isAuth = type && (type !== appConfig.plaltform.QQ || type !== appConfig.plaltform.SINA)
          if (!isAuth && to.name === 'auth') {
            next({path: '/'})
            return
          }
          if (isAuth && !token) {
            // 只有未登录的情况下才能够进入到授权页面
            next({query: {type, url}})
          } else if (isAuth && token) {
            if (!user) {
              fetchUser(store).then(() => {
                next({path: '/'})
              }).catch(() => {
                next({query: {type, url}})
              })
            } else {
              next({path: '/'})
            }
          } else { // 进入非登录、授权页的情况
            // 未登录情况下
            if (!token) {
              store.dispatch(types.app.SET_USER, null).then(() => {
                next({name: 'login',
                  query: {
                    [appConfig.cookie.REDRIECT_URL]: to.fullPath
                  }})
              })
              return
            }
            // 非授权页面情况
            if (token && !user) {
              fetchUser(store).then(() => {
                next()
              }).catch(() => {
                next({name: 'login',
                  query: {
                    [appConfig.cookie.REDRIECT_URL]: to.fullPath
                  }})
              })
            } else {
              next()
            }
          }
        }
      } else {
        // 有token 没用户 要拉取用户
        if (token && !user && to.name === 'register') {
          fetchUser(store, isWx).then(() => {
            next({path: '/'})
          }).catch(() => {
            next()
          })
          return
        }
        if (token && !user) {
          fetchUser(store).then(() => {
            next()
          }).catch(() => {
            next()
          })
          return
        }
        next()
      }
    } catch (err) {
      alert(err)
    }
  })
  router.afterEach(() => {
    Vue.prototype.$Progress.finish()
  })
}



// WEBPACK FOOTER //
// ./src/router/interceptor.js